/*Submission Page*/
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Service from "../Service/http";
import AceEditor from "react-ace";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ClipLoader } from "react-spinners";
import { FiRefreshCcw } from "react-icons/fi";
// import Modal from './Modal';

function Submission(){

  let service = new Service();
  
  const [cur_submission_verdict, SetCur_submission_verdict] = useState("");
  let [submissionData, setSubmissionData] = useState([]);
  const { id } = useParams();
  //Copy Button
  let [isCopied, setCopy] = useState(false);
  
  async function copyTextToClipboard(text){
    if('clipboard' in navigator){
      return await navigator.clipboard.writeText(text);
    }
    else{
      return document.execCommand('copy',true,text);
    }
  }

  const handleCopyClick = () =>{
    copyTextToClipboard(submissionData[8]).then(()=>{
      setCopy(true);
      setTimeout(()=>{
        setCopy(false);
      }, 1500);
    })
    .catch((err)=>{
      console.log(err);
    });
  }
  
  const originalWarn = console.warn;
  console.warn = function (...args) {
      const arg = args && args[0];
      if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;
      originalWarn(...args);
  };

  const onReevaluate = () =>{
    SetCur_submission_verdict("PENDING");
    if (submissionData[5] == "PENDING"){
      service.get("api/re-evaluate/submission/old/"+id);
    }
    else{
      service.get("api/re-evaluate/submission/new/"+id);
    }
    handleSubmit();
  }

  const getDelay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  const handleSubmit = async () => {
    SetCur_submission_verdict("PENDING");
    let attempts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let data = [];
    for await (let attempt of attempts) {
      try {
        const json = await service.get("api/submission/" + id);
        setSubmissionData(json);
        data = json;
        // let obj_poll_st = {};
        // obj_poll_st[json[0]] = json[11];
        // let obj_verdict = {};
        // obj_verdict[json[0]] = json[5];
        // SetServer_polling_status({...server_polling_status, obj_poll_st });
        // SetSubmission_verdicts({...submission_verdicts, obj_verdict });
        if (json[11] == false) {
          break;
        }
        await getDelay(10000);
      }
      catch (err) {
        console.log(err);
      }
    }
    SetCur_submission_verdict(data[5]);
  }

  /*Getting the details of submission*/
  useEffect(() => {
    handleSubmit();
  }, []);
  return (
    <div>
      {submissionData.length > 0 ? <div>
          <Modal show={true} fullscreen={true}>
            <Modal.Header >
              <Modal.Title><a href={"/submission/" + submissionData[0]} target="_blank">{submissionData[0]}</a> | <Link to={"/coding/profile/" + submissionData[1]} >{submissionData[2]}</Link>'s submission for the problem <Link to={"/code/" + submissionData[3]}>{submissionData[4]}</Link></Modal.Title>
            </Modal.Header>
            <Modal.Body><Table striped bordered hover size='sm' className="p-0" style={{ alignContent: 'center' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Result</th>
                  <th style={{ textAlign: 'center' }}>Language</th>
                  <th style={{ textAlign: 'center' }}>Submited At</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: cur_submission_verdict === 'ACCEPTED' ? "#76B947" : (cur_submission_verdict === 'PENDING') || (cur_submission_verdict == 'SERVER ERROR') ? "Gray" : "#E43D40" }}>
                  <div style={{
                      display: "flex", gap : ".4rem" ,flexDirection: "row", justifyContent: "center", alignItems: "center",
                    }}>
                      <div style={{
                        marginTop: ".3rem"
                      }}>
                        {( submissionData[11] === true) ?
                          <ClipLoader style={{
                            marginTop : "1rem !important"
                          }} color="LightSkyBlue" size="16" />
                          : (submissionData[11]) === false && (cur_submission_verdict =="PENDING")
                          ? <FiRefreshCcw  title="Refresh" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" /> : (submissionData[11]) === false && (cur_submission_verdict =="SERVER ERROR")? <FiRefreshCcw  title="Re-evaluate" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" />: null } </div> <div>{cur_submission_verdict} </div>
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>{submissionData[6]}</td>
                  <td style={{ textAlign: 'center' }}>{new Date(submissionData[7]).toLocaleString()}
                  </td>
                </tr>

              </tbody>
            </Table>

            {(submissionData[11] == false) && (cur_submission_verdict!="PENDING" && cur_submission_verdict!="SERVER ERROR")?<div style={{ backgroundColor: "#FEF1CD", padding: "0.5em 0.5em 0.5em 0.5em" }}>{submissionData[9]} / {submissionData[10]} passed</div>:null}<p></p>
              <Button variant="secondary" onClick={handleCopyClick} style={{ float: "right" }}><span>{isCopied ? 'Copied!' : 'Copy Code'}</span></Button>

              <AceEditor
                mode={submissionData[6] === 'cpp' ? 'c_cpp' : (submissionData[6] === 'c#' ? 'csharp' : submissionData[6])}
                theme="solarized_dark"
                value={submissionData[8]}
                readOnly={true}
                width="auto"
              /></Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
          </Modal></div> : null}
      </div>
  );
}
export default Submission;